import React from 'react';
export function Footer() {
  return <footer className="py-8 md:py-12 px-4 sm:px-6 lg:px-8 bg-zinc-950 border-t border-zinc-900" data-id="element-44">
      <div className="max-w-6xl mx-auto text-center space-y-3 md:space-y-4" data-id="element-45">
        <div className="flex items-center justify-center gap-2 mb-4 md:mb-6" data-id="element-46">
          <div className="w-2 h-2 rounded-full bg-[#00b8ff]" data-id="element-47"></div>
          <span className="text-xl md:text-2xl font-bold text-white tracking-tight" data-id="element-48">
            PALABRA VIVA
          </span>
        </div>

        <p className="text-zinc-600 text-xs md:text-sm" data-id="element-49">
          © 2026 Palabra Viva. Todos los derechos reservados.
        </p>

        <div className="flex items-center justify-center gap-3 md:gap-4 text-zinc-600 text-xs md:text-sm flex-wrap" data-id="element-50">
          <a href="https://www.palabraviva.com" className="hover:text-[#00b8ff] transition-colors" data-id="element-51">
            www.palabraviva.com
          </a>
          <span data-id="element-52">|</span>
          <a href="https://instagram.com/palabraviva" className="hover:text-[#00b8ff] transition-colors" data-id="element-53">
            @palabraviva
          </a>
        </div>

        <p className="text-zinc-700 text-[10px] md:text-xs max-w-3xl mx-auto leading-relaxed pt-4 md:pt-6 border-t border-zinc-900" data-id="element-54">
          Este material es de uso exclusivo del comprador. Queda prohibida su
          reproducción, distribución o reventa parcial o total sin autorización
          expresa de Palabra Viva.
        </p>
      </div>
    </footer>;
}